import React from "react";

const SearchBox = ({
  activeconsulta,
  handleSearchChange,
  handleSearchClick,
  handleSearchKeyUp
  ,value,
  lessAndMore = true,
}) => {
  return (
    <div
      className={
        activeconsulta
          ? "block-header__search-box is-active"
          : "block-header__search-box"
      }
    >
      <div className="block-header__search-box-nav">
       {lessAndMore && 
        <>
          <a
              onClick={() => handleSearchKeyUp("less")}
              className="block-header__search-box-icon material-icons"
            >
              expand_less
            </a>
            <a
              onClick={() => handleSearchKeyUp("more")}
              className="block-header__search-box-icon material-icons"
            >
              expand_more
            </a>
        </>
        }
        <input
          id="searchTerms"
          name="searchTerms"
          autoFocus={true}
          value={value}
          onChange={event =>
            handleSearchChange({
              searchText: event.target.value,
              arrowterm: 0
            })
          }
          type="text"
          placeholder="Pesquisar mensagens..."
          className="block-header__search-box-input"
        />
        <button
          onClick={handleSearchClick}
          className="block-header__search-box-button"
        >
          Concluir
        </button>
      </div>
    </div>
  );
};

export default SearchBox;
